import { createFeature, createReducer, on } from '@ngrx/store';

import { OperatorCompaniesActions } from '../actions/operator-companies.actions';
import { INITIAL_OPERATOR_COMPANIES_STATE } from '../operator-companies.state';

export const operatorCompaniesFeatureKey = 'operatorCompanies';

export const operatorCompaniesReducer = createReducer(
  INITIAL_OPERATOR_COMPANIES_STATE,

  on(OperatorCompaniesActions.loadCompanies, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(OperatorCompaniesActions.loadCompaniesSuccess, (state, { companies }) => ({
    ...state,
    companies,
    isLoading: false,
    error: null,
  })),

  on(OperatorCompaniesActions.loadCompaniesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(
    OperatorCompaniesActions.resetState,
    () => INITIAL_OPERATOR_COMPANIES_STATE,
  ),
);

export const operatorCompaniesFeature = createFeature({
  name: operatorCompaniesFeatureKey,
  reducer: operatorCompaniesReducer,
});
